import { EVENT_INTERACTION } from '@eventbrite/eds-event-card';
import { useCallback, useEffect } from 'react';
import {
    EventInteraction,
    InteractionCustomEvent,
    PLACE_EVENT_INTERACTION,
} from './types';

export function usePlacementEventContextAggregator<EventContext = {}>(
    placeElement: { current: HTMLElement | null },
    getPlaceInteractionInfo: (
        eventInteraction: EventInteraction,
    ) => EventContext,
) {
    const logInteractions = useCallback(
        (e: InteractionCustomEvent) => {
            e.preventDefault();

            const placeEventInteractionEvent = new CustomEvent(
                PLACE_EVENT_INTERACTION,
                {
                    detail: {
                        ...e.detail,
                        ...getPlaceInteractionInfo(e.detail),
                    },
                    bubbles: true,
                },
            );
            e.currentTarget?.dispatchEvent(placeEventInteractionEvent);
        },
        [getPlaceInteractionInfo],
    );

    useEffect(() => {
        const cardContainer = placeElement.current;
        cardContainer?.addEventListener(EVENT_INTERACTION, logInteractions);
        return () =>
            cardContainer?.removeEventListener(
                EVENT_INTERACTION,
                logInteractions,
            );
    }, [placeElement, logInteractions]);
}
